export enum PaymentAccountType {
    LEMONWAY = 'lemonway',
    SECUPAY = 'secupay',
}
